module.exports = __webpack_public_path__ + "static/media/appdrawer.8e31b6b9.svg";